import React from 'react';
import { cartPath } from 'utils/paths';
import NavLink from '../../NavLink';

import styles from './styles.module.scss';
import enhance from './enhance';
import PropTypes from 'prop-types';

import emptyCartIcon from './cart-icon.svg';
import fullCartIcon from './icon-cart-full.svg';

export const text = {
  altAlertIcon: 'Alert Icon',
  altCartIcon: 'Cart Icon',
};

export const CartNavLink = ({ totalCartQuantity }) => (
  <NavLink to={cartPath}>
    <div className={styles.cartLink}>
      <span className={styles.quantity}>({totalCartQuantity})</span>
      <img
        alt={text.altCartIcon}
        src={totalCartQuantity > 0 ? fullCartIcon : emptyCartIcon}
      />
    </div>
  </NavLink>
);

CartNavLink.propTypes = {
  totalCartQuantity: PropTypes.number.isRequired,
};

export default enhance(CartNavLink);
